.chartCards{background-color:#fafad2}
/*# sourceMappingURL=graph.component-JR4KDFMZ.css.map */
